export default __webpack_public_path__ + "static/media/KOD0114-min.0dadffd5.webp";